/**
 * Formats hours description text into aligned JSX elements
 * Splits comma-separated hours and aligns day/time pairs
 * 
 * @param hoursDescText - Stripped HTML hours description text
 * @returns JSX fragment with formatted hours or null
 * 
 * @example
 * Input: "Mon-Fri 10:30am - 9pm, Sat 11am-9pm, Sun 11am-7pm"
 * Output: Aligned display with days in left column, times in right column
 */
export const formatHoursDescription = (hoursDescText: string | null): JSX.Element | null => {
  if (!hoursDescText) return null

  return (
    <>
      {hoursDescText.split(',').map((part, i) => {
        const trimmed = part.trim()
        const firstSpaceIndex = trimmed.indexOf(' ')

        if (firstSpaceIndex === -1) {
          return (
            <span key={i} style={{ display: 'block' }}>
              {trimmed}
            </span>
          )
        }

        const day = trimmed.substring(0, firstSpaceIndex)
        const time = trimmed.substring(firstSpaceIndex + 1)

        return (
          <span key={i} style={{ display: 'flex', gap: '0.5rem' }}>
            <span style={{ minWidth: '10rem', display: 'inline-block' }}>{day}</span>
            <span>{time}</span>
          </span>
        )
      })}
    </>
  )
}
